<template>
    <v-card
            class="ma-0 py-0 mb-0"
            dense>
        <v-card-title class="subtitle-2">
            {{ field.title }}
        </v-card-title>
        <v-card-subtitle>{{ field.description }}</v-card-subtitle>
        <v-card-text v-html="field.html.content" />
    </v-card>
</template>

<script>
    import Value from "../../../../../models/value.model";
    import Field from "@/models/field.model";

    export default {
        name: "FieldHtmlComponent",
        props: {
            field: {type: Object, default: () => new Field()},
        },
        mounted() {
            this.getValue().then((value) => {
                this.$emit('updateValue', value);
            })
        },
        methods: {
            async getValue() {
                return new Value({
                    value: true,
                    isValid: true,
                    isEmpty: false,
                });
            }
        }
    }
</script>